import type { DemoKey } from '../types';

export const vi: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Toán · Thống kê',
  'app.title': 'Thống kê',
  'panel.experiment': 'Cảnh',
  'panel.params': 'Tham số',

  'exp.survey-explorer.title': 'Trình duyệt khảo sát',
  'exp.survey-explorer.desc': 'Chọn một cột; demo tự chọn tóm tắt phù hợp.',
  'exp.distribution-sculptor.title': 'Nhà điêu khắc phân phối',
  'exp.distribution-sculptor.desc': 'Kéo điểm để xem thống kê phản ứng.',
  'exp.two-variable-lab.title': 'Phòng thí nghiệm hai biến',
  'exp.two-variable-lab.desc': 'Tán xạ, khớp, và câu hỏi nhân quả.',
  'exp.sampling-lab.title': 'Phòng thí nghiệm lấy mẫu',
  'exp.sampling-lab.desc': 'Cách kỹ thuật và cỡ mẫu dịch chuyển trung bình mẫu.',
  'exp.probability-diagrams.title': 'Biểu đồ xác suất',
  'exp.probability-diagrams.desc': 'Cách nhìn Venn và cây cho biến cố hợp.',

  'type.qualitative-nominal.label': 'Định tính · danh nghĩa',
  'type.qualitative-nominal.def': 'Hạng mục không có thứ tự nội tại.',
  'type.qualitative-ordinal.label': 'Định tính · thứ tự',
  'type.qualitative-ordinal.def': 'Hạng mục có thứ tự có nghĩa.',
  'type.qualitative-multi.label': 'Định tính · nhiều giá trị',
  'type.qualitative-multi.def': 'Mỗi quan sát có thể có nhiều thẻ.',
  'type.quantitative-discrete.label': 'Định lượng · rời rạc',
  'type.quantitative-discrete.def': 'Số đến theo bước cố định.',
  'type.quantitative-continuous.label': 'Định lượng · liên tục',
  'type.quantitative-continuous.def': 'Số đo trên thang liên tục.',

  'column.name.label': 'Tên học sinh',
  'column.height_cm.label': 'Chiều cao',
  'column.shoe_size_eu.label': 'Cỡ giày (EU)',
  'column.study_hours.label': 'Giờ học / tuần',
  'column.test_score.label': 'Điểm kiểm tra',
  'column.sports_played.label': 'Môn thể thao chơi',
  'column.eye_color.label': 'Màu mắt',
  'column.commute_min.label': 'Đi học',
  'column.grade_year.label': 'Lớp',
  'column.homework_effort.label': 'Nỗ lực bài tập',
  'column.ice-cream-sales.label': 'Doanh số kem',
  'column.drownings.label': 'Đuối nước',
  'column.month.label': 'Tháng',
  'column.storks.label': 'Cò',
  'column.births.label': 'Sinh nở',
  'column.country_area_km2.label': 'Diện tích quốc gia',
  'column.sleep_hours.label': 'Giờ ngủ',
  'column.reaction_ms.label': 'Thời gian phản ứng',

  'dataset.master-survey.label': 'Khảo sát lớp',
  'dataset.master-survey.desc': '30 học sinh mô phỏng.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Doanh số kem vs đuối nước',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Cả hai lên xuống theo mùa. Đuối nước không gây ra doanh số kem.',
  'dataset.spurious-storks-vs-births.label': 'Cò vs sinh nở',
  'dataset.spurious-storks-vs-births.desc':
    'Quốc gia lớn có nhiều cò và nhiều ca sinh. Chim không phải nguyên nhân.',
  'dataset.real-sleep-vs-reaction-time.label': 'Ngủ vs thời gian phản ứng',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Ngủ nhiều hơn, phản ứng nhanh hơn. Tương quan âm thực sự — kèm cơ chế hợp lý.',

  'tag.football.label': 'Bóng đá',
  'tag.basketball.label': 'Bóng rổ',
  'tag.volleyball.label': 'Bóng chuyền',
  'tag.swimming.label': 'Bơi',
  'tag.none.label': 'Không',

  'population.gaussian.label': 'Đường cong chuông',
  'population.right-skewed.label': 'Lệch phải',
  'population.bimodal.label': 'Hai đỉnh (có tầng)',
  'population.uniform.label': 'Đều',

  'venn.dice-even-or-prime.label': 'Xúc xắc: chẵn hoặc nguyên tố',
  'venn.class-sports-2set.label': 'Thể thao (2 tập)',
  'venn.class-sports-3set.label': 'Thể thao (3 tập)',
  'venn.custom.label': 'Tuỳ chỉnh',

  'tree.draw-without-replacement.label': 'Rút không hoàn lại',
  'tree.custom.label': 'Tuỳ chỉnh',
  'tree.coin.heads': 'N',
  'tree.coin.tails': 'S',
  'tree.draw.start': 'Túi: 2 đỏ, 3 xanh',
  'tree.draw.red': 'Đỏ',
  'tree.draw.blue': 'Xanh',
  'tree.custom.start': 'Bắt đầu',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Biểu đồ tần suất',
  'card.cumulative': 'Tần suất tích luỹ',
  'card.box': 'Biểu đồ hộp',
  'card.summary': 'Tóm tắt 5 số',
  'card.bar': 'Biểu đồ cột',
  'card.mode': 'Mốt',
  'card.tag-frequency': 'Tần suất thẻ',
  'card.mode-tag': 'Thẻ phổ biến',
  'card.empty-no-order': 'Không áp dụng',
  'card.empty-multi': 'Không áp dụng',
  'card.numberline': 'Trục số',
  'card.scatter': 'Tán xạ',
  'card.description': 'Đang xảy ra',
  'card.population': 'Tổng thể',
  'card.sampling-distribution': 'Trung bình mẫu',
  'card.venn': 'Venn',
  'card.tree': 'Cây',
  'card.probabilities': 'Xác suất',

  'param.dataset.label': 'Tập dữ liệu',
  'param.column.label': 'Cột',
  'param.bins.label': 'Khoảng',
  'param.shape.label': 'Hình dạng ban đầu',
  'param.show-mean.label': 'Hiện trung bình',
  'param.show-median.label': 'Hiện trung vị',
  'param.x-col.label': 'Cột X',
  'param.y-col.label': 'Cột Y',
  'param.show-regression.label': 'Đường hồi quy',
  'param.show-residuals.label': 'Phần dư',
  'param.show-confounder.label': 'Hiện yếu tố gây nhiễu',
  'param.population.label': 'Tổng thể',
  'param.technique.label': 'Kỹ thuật',
  'param.sample-size.label': 'Cỡ mẫu',
  'param.stratum.label': 'Tầng',
  'param.bias.label': 'Thiên lệch',
  'param.mode.label': 'Chế độ',
  'param.preset.label': 'Cài sẵn',
  'param.universe.label': 'Cỡ không gian',
  'param.show-prob.label': 'Hiện xác suất',
  'param.treat-as-numeric.label': 'Xem là số',

  'stat.count': 'Số lượng',
  'stat.mean': 'Trung bình',
  'stat.median': 'Trung vị',
  'stat.range': 'Khoảng biến thiên',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Giá trị ngoại lai',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': 'Hệ số góc',
  'stat.intercept': 'Hệ số tự do',
  'stat.n': 'n',
  'stat.population-mean': 'Trung bình thực',
  'stat.latest-sample-mean': 'Trung bình mẫu',
  'stat.sample-mean-spread': 'SD trung bình mẫu',
  'stat.sample-count': 'Mẫu đã lấy',
  'outlier.upper': 'Ngoại lai trên',
  'outlier.lower': 'Ngoại lai dưới',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Lấy lại mẫu',
  'btn.run-100': 'Lấy 100 mẫu',
  'btn.stop': 'Dừng',
  'btn.clear-history': 'Xoá lịch sử',

  'explainer.no-order': 'Không thứ tự → không tích luỹ, không hộp.',
  'explainer.multi-no-iqr': 'Nhiều giá trị → tứ phân vị / IQR không xác định.',
  'message.no-data': 'Không có dữ liệu.',
  'message.needs-quartiles': 'Cần ≥4 điểm cho tứ phân vị.',
  'message.x-zero-variance': 'X có phương sai bằng 0 — không thể khớp đường.',
  'message.n-too-small': 'n quá nhỏ.',
  'message.stratum-clamp': 'Tầng có ít hàng hơn yêu cầu — dùng tất cả.',
  'message.siblings-sum-to-one': 'Các nút con phải có tổng bằng 1.',
};
